module.exports = __webpack_public_path__ + "img/m2_cn.c95b074.jpg";